import React, { Component } from "react";
import { UserMenuItems } from "../../Constants/Constants";
import { getMainClassName } from "../../Constants/Utilities";
import MainPage from "../MainPage";
import { UpdatePassword } from "./UpdatePassword";

export default class Settings extends Component {
  constructor(props) {
    super(props);
    console.log("Settings props", props);
    this.isSinglePage = true;
    this.header = (props.parentBread || []).concat({
      title: (
        <>
          {UserMenuItems.updatePassword.icon()}
          <span>Settings</span>
        </>
      ),
    });
    this.state = {
      action: null,
    };
  }

  settingNavigation = (single = false) => {
    return (
      <MainPage>
        <div className="single-page back-image padding">
          <UpdatePassword parentBread={this.header} />
        </div>
      </MainPage>
    );
  };
  render() {
    const { groupRecord } = this.props;
    return this.isSinglePage ? (
      this.settingNavigation(!groupRecord)
    ) : groupRecord ? (
      this.settingNavigation(false)
    ) : (
      <MainPage>{this.settingNavigation(false)}</MainPage>
    );
  }
}
